import { TableCell, TableRow } from "@/components/_atoms/table";

interface MunicipalPropertyTableSpacerRowProps {
  height: number;
  columnCount: number;
}

export function MunicipalPropertyTableSpacerRow({ height, columnCount }: MunicipalPropertyTableSpacerRowProps) {
  if (height <= 0) {
    return null;
  }

  return (
    <TableRow aria-hidden="true" className="h-0 border-0">
      <TableCell colSpan={columnCount} className="p-0" style={{ height }} />
    </TableRow>
  );
}
